import request from '../request'
import type { ApiResponse } from '../types'
import type {
  notifySyncResponse,
  notifyAckRequest,
  notifyCenterUnreadResponse,
  notifyCenterListRequest,
  notifyCenterListResponse,
} from './types'
export * from './types'

/**
 * websocket通知测试
 */
export function notifyNatsechoApi(): Promise<ApiResponse<any>> {
  return request.get('/notify/nats-echo')
}

/**
 * 首页所有通知初始化数据
 */
export function notifySyncApi(): Promise<ApiResponse<notifySyncResponse>> {
  return request.post('/notify/sync')
}

/**
 * 通知-请求已读
 */
export function notifyAckApi(data: notifyAckRequest): Promise<ApiResponse<any>> {
  return request.post('/notify/ack', data)
}

/**
 * 通知中心未读
 */
export function notifyCenterUnreadApi(): Promise<ApiResponse<notifyCenterUnreadResponse>> {
  return request.get('/notify/center/unread')
}

/**
 * 通知中心列表
 */
export function notifyCenterListApi(
  data: notifyCenterListRequest,
): Promise<ApiResponse<notifyCenterListResponse>> {
  return request.post('/notify/center/list', data)
}
